/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router';

import { Route as rootRouteImport } from './routes/__root';

const LayoutLazyRouteImport = createFileRoute('/_layout')();
const LayoutIndexLazyRouteImport = createFileRoute('/_layout/')();
const LayoutTermsLazyRouteImport = createFileRoute('/_layout/terms')();
const LayoutPrivacyLazyRouteImport = createFileRoute('/_layout/privacy')();
const LayoutContactLazyRouteImport = createFileRoute('/_layout/contact')();
const LayoutProductsIndexLazyRouteImport =
  createFileRoute('/_layout/products/')();
const LayoutProductsAssistantLazyRouteImport = createFileRoute(
  '/_layout/products/assistant',
)();
const LayoutProductsAssistantIndexLazyRouteImport = createFileRoute(
  '/_layout/products/assistant/',
)();
const LayoutProductsAssistantDemosSlugLazyRouteImport = createFileRoute(
  '/_layout/products/assistant/demos/$slug',
)();

const LayoutLazyRoute = LayoutLazyRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/_layout.lazy').then((d) => d.Route));
const LayoutIndexLazyRoute = LayoutIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutLazyRoute,
} as any).lazy(() =>
  import('./routes/_layout/index.lazy').then((d) => d.Route),
);
const LayoutTermsLazyRoute = LayoutTermsLazyRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => LayoutLazyRoute,
} as any).lazy(() =>
  import('./routes/_layout/terms.lazy').then((d) => d.Route),
);
const LayoutPrivacyLazyRoute = LayoutPrivacyLazyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => LayoutLazyRoute,
} as any).lazy(() =>
  import('./routes/_layout/privacy.lazy').then((d) => d.Route),
);
const LayoutContactLazyRoute = LayoutContactLazyRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => LayoutLazyRoute,
} as any).lazy(() =>
  import('./routes/_layout/contact.lazy').then((d) => d.Route),
);
const LayoutProductsIndexLazyRoute = LayoutProductsIndexLazyRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => LayoutLazyRoute,
} as any).lazy(() =>
  import('./routes/_layout/products/index.lazy').then((d) => d.Route),
);
const LayoutProductsAssistantLazyRoute =
  LayoutProductsAssistantLazyRouteImport.update({
    id: '/products/assistant',
    path: '/products/assistant',
    getParentRoute: () => LayoutLazyRoute,
  } as any).lazy(() =>
    import('./routes/_layout/products/assistant.lazy').then((d) => d.Route),
  );
const LayoutProductsAssistantIndexLazyRoute =
  LayoutProductsAssistantIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LayoutProductsAssistantLazyRoute,
  } as any).lazy(() =>
    import('./routes/_layout/products/assistant/index.lazy').then(
      (d) => d.Route,
    ),
  );
const LayoutProductsAssistantDemosSlugLazyRoute =
  LayoutProductsAssistantDemosSlugLazyRouteImport.update({
    id: '/demos/$slug',
    path: '/demos/$slug',
    getParentRoute: () => LayoutProductsAssistantLazyRoute,
  } as any).lazy(() =>
    import('./routes/_layout/products/assistant/demos/$slug.lazy').then(
      (d) => d.Route,
    ),
  );

export interface FileRoutesByFullPath {
  '/contact': typeof LayoutContactLazyRoute;
  '/privacy': typeof LayoutPrivacyLazyRoute;
  '/terms': typeof LayoutTermsLazyRoute;
  '/': typeof LayoutIndexLazyRoute;
  '/products/assistant': typeof LayoutProductsAssistantLazyRouteWithChildren;
  '/products': typeof LayoutProductsIndexLazyRoute;
  '/products/assistant/': typeof LayoutProductsAssistantIndexLazyRoute;
  '/products/assistant/demos/$slug': typeof LayoutProductsAssistantDemosSlugLazyRoute;
}
export interface FileRoutesByTo {
  '/contact': typeof LayoutContactLazyRoute;
  '/privacy': typeof LayoutPrivacyLazyRoute;
  '/terms': typeof LayoutTermsLazyRoute;
  '/': typeof LayoutIndexLazyRoute;
  '/products': typeof LayoutProductsIndexLazyRoute;
  '/products/assistant': typeof LayoutProductsAssistantIndexLazyRoute;
  '/products/assistant/demos/$slug': typeof LayoutProductsAssistantDemosSlugLazyRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/_layout': typeof LayoutLazyRouteWithChildren;
  '/_layout/contact': typeof LayoutContactLazyRoute;
  '/_layout/privacy': typeof LayoutPrivacyLazyRoute;
  '/_layout/terms': typeof LayoutTermsLazyRoute;
  '/_layout/': typeof LayoutIndexLazyRoute;
  '/_layout/products/assistant': typeof LayoutProductsAssistantLazyRouteWithChildren;
  '/_layout/products/': typeof LayoutProductsIndexLazyRoute;
  '/_layout/products/assistant/': typeof LayoutProductsAssistantIndexLazyRoute;
  '/_layout/products/assistant/demos/$slug': typeof LayoutProductsAssistantDemosSlugLazyRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/contact'
    | '/privacy'
    | '/terms'
    | '/'
    | '/products/assistant'
    | '/products'
    | '/products/assistant/'
    | '/products/assistant/demos/$slug';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/contact'
    | '/privacy'
    | '/terms'
    | '/'
    | '/products'
    | '/products/assistant'
    | '/products/assistant/demos/$slug';
  id:
    | '__root__'
    | '/_layout'
    | '/_layout/contact'
    | '/_layout/privacy'
    | '/_layout/terms'
    | '/_layout/'
    | '/_layout/products/assistant'
    | '/_layout/products/'
    | '/_layout/products/assistant/'
    | '/_layout/products/assistant/demos/$slug';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  LayoutLazyRoute: typeof LayoutLazyRouteWithChildren;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_layout': {
      id: '/_layout';
      path: '';
      fullPath: '';
      preLoaderRoute: typeof LayoutLazyRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_layout/': {
      id: '/_layout/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof LayoutIndexLazyRouteImport;
      parentRoute: typeof LayoutLazyRoute;
    };
    '/_layout/terms': {
      id: '/_layout/terms';
      path: '/terms';
      fullPath: '/terms';
      preLoaderRoute: typeof LayoutTermsLazyRouteImport;
      parentRoute: typeof LayoutLazyRoute;
    };
    '/_layout/privacy': {
      id: '/_layout/privacy';
      path: '/privacy';
      fullPath: '/privacy';
      preLoaderRoute: typeof LayoutPrivacyLazyRouteImport;
      parentRoute: typeof LayoutLazyRoute;
    };
    '/_layout/contact': {
      id: '/_layout/contact';
      path: '/contact';
      fullPath: '/contact';
      preLoaderRoute: typeof LayoutContactLazyRouteImport;
      parentRoute: typeof LayoutLazyRoute;
    };
    '/_layout/products/': {
      id: '/_layout/products/';
      path: '/products';
      fullPath: '/products';
      preLoaderRoute: typeof LayoutProductsIndexLazyRouteImport;
      parentRoute: typeof LayoutLazyRoute;
    };
    '/_layout/products/assistant': {
      id: '/_layout/products/assistant';
      path: '/products/assistant';
      fullPath: '/products/assistant';
      preLoaderRoute: typeof LayoutProductsAssistantLazyRouteImport;
      parentRoute: typeof LayoutLazyRoute;
    };
    '/_layout/products/assistant/': {
      id: '/_layout/products/assistant/';
      path: '/';
      fullPath: '/products/assistant/';
      preLoaderRoute: typeof LayoutProductsAssistantIndexLazyRouteImport;
      parentRoute: typeof LayoutProductsAssistantLazyRoute;
    };
    '/_layout/products/assistant/demos/$slug': {
      id: '/_layout/products/assistant/demos/$slug';
      path: '/demos/$slug';
      fullPath: '/products/assistant/demos/$slug';
      preLoaderRoute: typeof LayoutProductsAssistantDemosSlugLazyRouteImport;
      parentRoute: typeof LayoutProductsAssistantLazyRoute;
    };
  }
}

interface LayoutProductsAssistantLazyRouteChildren {
  LayoutProductsAssistantIndexLazyRoute: typeof LayoutProductsAssistantIndexLazyRoute;
  LayoutProductsAssistantDemosSlugLazyRoute: typeof LayoutProductsAssistantDemosSlugLazyRoute;
}

const LayoutProductsAssistantLazyRouteChildren: LayoutProductsAssistantLazyRouteChildren =
  {
    LayoutProductsAssistantIndexLazyRoute:
      LayoutProductsAssistantIndexLazyRoute,
    LayoutProductsAssistantDemosSlugLazyRoute:
      LayoutProductsAssistantDemosSlugLazyRoute,
  };

const LayoutProductsAssistantLazyRouteWithChildren =
  LayoutProductsAssistantLazyRoute._addFileChildren(
    LayoutProductsAssistantLazyRouteChildren,
  );

interface LayoutLazyRouteChildren {
  LayoutContactLazyRoute: typeof LayoutContactLazyRoute;
  LayoutPrivacyLazyRoute: typeof LayoutPrivacyLazyRoute;
  LayoutTermsLazyRoute: typeof LayoutTermsLazyRoute;
  LayoutIndexLazyRoute: typeof LayoutIndexLazyRoute;
  LayoutProductsAssistantLazyRoute: typeof LayoutProductsAssistantLazyRouteWithChildren;
  LayoutProductsIndexLazyRoute: typeof LayoutProductsIndexLazyRoute;
}

const LayoutLazyRouteChildren: LayoutLazyRouteChildren = {
  LayoutContactLazyRoute: LayoutContactLazyRoute,
  LayoutPrivacyLazyRoute: LayoutPrivacyLazyRoute,
  LayoutTermsLazyRoute: LayoutTermsLazyRoute,
  LayoutIndexLazyRoute: LayoutIndexLazyRoute,
  LayoutProductsAssistantLazyRoute:
    LayoutProductsAssistantLazyRouteWithChildren,
  LayoutProductsIndexLazyRoute: LayoutProductsIndexLazyRoute,
};

const LayoutLazyRouteWithChildren = LayoutLazyRoute._addFileChildren(
  LayoutLazyRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  LayoutLazyRoute: LayoutLazyRouteWithChildren,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
